import SettingsPage from '../hoc/settings/settings';
import CardsSettings from '../hoc/settings/cards';
import ApplicationsSchemes from '../hoc/settings/applications/application-scheme';
import ApplicationsSchemesList from '../hoc/settings/applications/list';
import CurrenciesList from '../hoc/settings/currencies/currencies';
import CurrencyForm from '../hoc/settings/currencies/form';
import CountriesList from '../hoc/settings/countries/countries';
import CountryPanel from '../hoc/settings/countries/country';
import Agreements from '../hoc/settings/agreements';
import AgreementForm from '../hoc/settings/agreements-form';
import ApplicationScheme from '../hoc/settings/applications/scheme';
import PaymentTypes from '../hoc/settings/payment-types';
import TransactionsTypes from '../hoc/settings/transactions-types';
import TransactionSettingsPage from '../hoc/transation-settings/settings';
import BeneficiariesSettings from '../hoc/transation-settings/beneficiaries';
import TransactionOptions from '../hoc/transation-settings/transaction-options';
import CaspCurrencies from '../hoc/transation-settings/casp';
import Overdraft from '../hoc/transation-settings/overdraft';
import OtherSettings from '../hoc/settings/other-settings';
import PspSettings from '../hoc/psp-details';
import PspDetails from '../hoc/psp-details/details';
import PspRates from '../hoc/psp-details/rates';
import PspWebhooks from '../hoc/psp-details/webhooks';
import PspAuthorization from '../hoc/psp-details/authorization';
import PspBrand from '../hoc/psp-details/brand';
import PSPLanguages from '../hoc/psp-details/languages';
import PSPOtp from '../hoc/psp-details/otp';
import ProcessingRules from '../hoc/transation-settings/processing-rules/processing-rules';
import ProcessingRulesList from '../hoc/transation-settings/processing-rules/list';
import ProcessingRuleForm from '../hoc/transation-settings/processing-rules/form';
import IbanValidationSettings from '../hoc/transation-settings/iban-validation';
import PurposeCodes from '../hoc/transation-settings/purpose-codes';
import Dictionaries from '../hoc/dictionaries';
import DictionariesList from '../hoc/dictionaries/list';
import DictionaryItems from '../hoc/dictionaries/items';
import DictionaryItemForm from '../hoc/dictionaries/form';
import ReportsSettings from '../hoc/settings/reports';
import FintracReportSettings from '../hoc/settings/reports/fintrac';
import TopUpSettings from '../hoc/settings/top-up';
import StatementsSettings from '../hoc/settings/statements';

import ROUTES from '../routes';

const SettingsRoutes = {
  path: ROUTES.SETTINGS,
  element: <SettingsPage />,
  children: [
    {
      path: ROUTES.CURRENCIES,
      element: <CurrenciesList />,
      children: [
        {
          path: ROUTES.CURRENCIES_ITEM,
          element: <CurrencyForm />,
        },
      ],
    },
    {
      path: ROUTES.COUNTRIES,
      element: <CountriesList />,
      children: [
        {
          path: ROUTES.COUNTRY,
          element: <CountryPanel />,
        },
      ],
    },
    {
      path: ROUTES.PSP,
      element: <PspSettings />,
      children: [
        {
          path: ROUTES.PSP_DETAILS,
          element: <PspDetails />,
        },
        {
          path: ROUTES.PSP_RATES,
          element: <PspRates />,
        },
        {
          path: ROUTES.PSP_WEBHOOKS,
          element: <PspWebhooks />,
        },
        {
          path: ROUTES.PSP_AUTHORIZATION,
          element: <PspAuthorization />,
        },
        {
          path: ROUTES.PSP_BRAND,
          element: <PspBrand />,
        },
        {
          path: ROUTES.PSP_LANGUAGES,
          element: <PSPLanguages />,
        },
        {
          path: ROUTES.PSP_OTP,
          element: <PSPOtp />,
        },
      ],
    },
    {
      path: ROUTES.AGREEMENTS_LIST,
      element: <Agreements />,
      children: [
        {
          path: ROUTES.AGREEMENTS_ADD,
          element: <AgreementForm />,
        },
        {
          path: ROUTES.AGREEMENTS_READ,
          element: <AgreementForm />,
        },
      ],
    },
    { path: ROUTES.APPLICATION_ITEM, element: <ApplicationScheme /> },
    {
      path: ROUTES.OTHER_SETTINGS,
      element: <OtherSettings />,
      children: [
        {
          path: ROUTES.CARDS,
          element: <CardsSettings />,
        },
        {
          path: ROUTES.TOP_UP,
          element: <TopUpSettings />,
        },
        {
          path: ROUTES.STATEMENT,
          element: <StatementsSettings />,
        },
      ],
    },
    {
      path: ROUTES.APPLICATIONS,
      element: <ApplicationsSchemes />,
      children: [
        {
          path: ROUTES.APPLICATIONS_LIST,
          element: <ApplicationsSchemesList />,
        },
      ],
    },
    {
      path: ROUTES.TRANSACTION_SETTINGS,
      element: <TransactionSettingsPage />,
      children: [
        {
          path: ROUTES.TRANSACTION_SETTINGS_TR_TYPES,
          element: <TransactionsTypes />,
        },
        {
          path: ROUTES.TRANSACTION_SETTINGS_PAYMENT_TYPES,
          element: <PaymentTypes />,
        },
        {
          path: ROUTES.TRANSACTION_SETTINGS_BENEFICIARIES,
          element: <BeneficiariesSettings />,
        },
        {
          path: ROUTES.TRANSACTION_SETTINGS_OPTIONS,
          element: <TransactionOptions />,
        },
        {
          path: ROUTES.TRANSACTION_SETTINGS_OVERDRAFT,
          element: <Overdraft />,
        },
        {
          path: ROUTES.TRANSACTION_SETTINGS_CASP,
          element: <CaspCurrencies />,
        },
        {
          path: ROUTES.TRANSACTION_SETTINGS_IBAN,
          element: <IbanValidationSettings />,
        },
        {
          path: ROUTES.TRANSACTION_SETTINGS_PURPOSE_CODE,
          element: <PurposeCodes />,
        },
        {
          path: ROUTES.TRANSACTION_SETTINGS_PROCESSING_RULES,
          element: <ProcessingRules />,
          children: [
            {
              path: ROUTES.TRANSACTION_SETTINGS_PROCESSING_RULES_LIST,
              element: <ProcessingRulesList />,
              children: [
                {
                  path: ROUTES.TRANSACTION_SETTINGS_PROCESSING_RULES_CREATE,
                  element: <ProcessingRuleForm />,
                },
                {
                  path: ROUTES.TRANSACTION_SETTINGS_PROCESSING_RULES_EDIT,
                  element: <ProcessingRuleForm />,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      path: ROUTES.DICTIONARIES,
      element: <Dictionaries />,
      children: [
        {
          path: ROUTES.DICTIONARIES_LIST,
          element: <DictionariesList />,
        },
        {
          path: ROUTES.DICTIONARIES_LIST_ITEMS,
          element: <DictionaryItems />,
          children: [
            {
              path: ROUTES.DICTIONARIES_LIST_ITEMS_CREATE,
              element: <DictionaryItemForm />,
            },
            {
              path: ROUTES.DICTIONARIES_LIST_ITEMS_EDIT,
              element: <DictionaryItemForm />,
            },
          ],
        },
      ],
    },
    {
      path: ROUTES.REPORTS_SETTINGS,
      element: <ReportsSettings />,
      children: [
        {
          path: ROUTES.REPORTS_SETTINGS_FINTRAC,
          element: <FintracReportSettings />,
        },
      ],
    },
  ],
};

export default SettingsRoutes;
